import React from 'react';
import { SEO } from '../components/SEO';

const sections = [
  { id: 'umumi', title: 'Ümumi müddəalar' },
  { id: 'melumatlar', title: 'Toplanan məlumatlar' },
  { id: 'meqsedler', title: 'Məlumatların emal məqsədləri' },
  { id: 'esas', title: 'Emalın hüquqi əsası' },
  { id: 'paylasma', title: 'Üçüncü tərəflərlə paylaşma' },
  { id: 'muddet', title: 'Saxlanılma müddəti' },
  { id: 'huquqlar', title: 'İstifadəçinin hüquqları' },
  { id: 'tehlukesizlik', title: 'Təhlükəsizlik tədbirləri' },
  { id: 'cookie', title: 'Kuki faylları (Cookies)' },
  { id: 'deyisikliklr', title: 'Dəyişikliklər' },
  { id: 'elaqe', title: 'Əlaqə məlumatları' }
];

export const PrivacyPolicyPage = () => {
  return (
    <div className="bg-white">
      <SEO
        title="Məxfilik siyasəti | İDK BOKT"
        description="İDK BOKT-nin məxfilik siyasəti — şəxsi məlumatların toplanması, işlənməsi və qorunması qaydaları."
        path="/mexfilik-siyaseti"
      />
      {/* Hero */}
      <section className="bg-gradient-to-b from-blue-50 to-white pt-12 pb-8">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center">
          <span className="inline-block text-xs font-semibold text-blue-700 uppercase tracking-[0.2em] mb-3">
            Hüquqi sənəd
          </span>
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4 font-serif-display">Məxfilik siyasəti</h1>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            Sonuncu yenilənmə tarixi: 1 fevral 2026
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="pt-8 pb-24">
        <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
            {/* Sticky table of contents */}
            <aside className="lg:col-span-4">
              <div className="lg:sticky lg:top-28">
                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-4">
                  Bu səhifədə
                </p>
                <nav className="space-y-1">
                  {sections.map((s, idx) => (
                    <a
                      key={s.id}
                      href={`#${s.id}`}
                      className="block text-sm text-gray-600 hover:text-blue-700 py-1.5 transition-colors"
                    >
                      <span className="font-mono text-xs text-gray-400 mr-2">
                        {String(idx + 1).padStart(2, '0')}
                      </span>
                      {s.title}
                    </a>
                  ))}
                </nav>
              </div>
            </aside>

            {/* Main content */}
            <div className="lg:col-span-8 prose-section space-y-12 text-gray-700">
              <Section id="umumi" title="1. Ümumi müddəalar">
                <p>
                  &quot;İnkişafa Dəstək Kreditləri&quot; Bank Olmayan Kredit Təşkilatı Məhdud Məsuliyyətli Cəmiyyəti (bundan sonra — &quot;İnkişafa Dəstək Kreditləri BOKT&quot;,
                  &quot;biz&quot;) müştərilərinin və sayt ziyarətçilərinin şəxsi məlumatlarının məxfiliyini qoruyur və onların
                  qanunauyğun emalını təmin edir.
                </p>
                <p>
                  Bu Məxfilik siyasəti Azərbaycan Respublikasının &quot;Fərdi məlumatlar haqqında&quot; Qanununa,
                  &quot;Bank olmayan kredit təşkilatları haqqında&quot; Qanununa və digər müvafiq qanunvericilik aktlarına
                  uyğun olaraq hazırlanmışdır. Bu sənəddə istifadə olunan &quot;şəxsi məlumat&quot; termini &quot;Fərdi məlumatlar
                  haqqında&quot; Qanunda göstərilən &quot;fərdi məlumat&quot; anlayışı ilə eyni mənanı daşıyır.
                </p>
              </Section>

              <Section id="melumatlar" title="2. Toplanan məlumatlar">
                <p>İnkişafa Dəstək Kreditləri BOKT şəxsi məlumatları iki əsas kanaldan əldə edir:</p>

                <p><strong>a) Sayt vasitəsilə toplanan məlumatlar:</strong></p>
                <ul>
                  <li><strong>Əlaqə forması üzərindən:</strong> ad, soyad, telefon nömrəsi, seçilmiş məhsul növü və mesaj mətni.</li>
                  <li><strong>Texniki məlumatlar:</strong> IP ünvan, brauzer növü, cihaz növü, sayta giriş tarixi və müddəti (server qeydləri vasitəsilə).</li>
                </ul>

                <p><strong>b) Kredit prosesinin ofisdə rəsmiləşdirilməsi zamanı toplanan məlumatlar:</strong></p>
                <ul>
                  <li><strong>Şəxsi identifikasiya:</strong> ata adı, doğum tarixi, şəxsiyyət vəsiqəsinin nömrəsi, FİN.</li>
                  <li><strong>Əlaqə məlumatları:</strong> e-poçt ünvanı, yaşayış və qeydiyyat ünvanı.</li>
                  <li><strong>Maliyyə məlumatları:</strong> gəlir mənbəyi və məbləği, iş yeri, kredit tarixçəsi, mövcud öhdəliklər.</li>
                  <li><strong>Sənədlər:</strong> şəxsiyyət vəsiqəsi, gəlir arayışı, mülkiyyət sənədləri və digər kreditləşmə üçün lazımi sənədlər.</li>
                </ul>

                <p>
                  <em>Qeyd: Saytda sənəd yükləmə funksiyası yoxdur. Şəxsiyyət vəsiqəsi və digər kreditləşmə sənədləri
                  yalnız müraciətin ofisdə rəsmiləşdirilməsi mərhələsində, birbaşa təqdim edilir.</em>
                </p>
              </Section>

              <Section id="meqsedler" title="3. Məlumatların emal məqsədləri">
                <p>Toplanan şəxsi məlumatlar aşağıdakı məqsədlərlə emal olunur:</p>
                <ul>
                  <li>Kredit müraciətlərinin qəbulu, qiymətləndirilməsi və icrası;</li>
                  <li>Müştəri identifikasiyası və yoxlama prosedurları (KYC);</li>
                  <li>Kredit risklərinin qiymətləndirilməsi;</li>
                  <li>Hüquqi öhdəliklərin yerinə yetirilməsi (Mərkəzi Bank, vergi və digər orqanlar qarşısında);</li>
                  <li>Müştəri xidmətlərinin göstərilməsi və əlaqənin saxlanılması;</li>
                  <li>Saytın funksionallığının təmin olunması və yaxşılaşdırılması;</li>
                  <li>Saxtakarlığın və qanunsuz fəaliyyətin qarşısının alınması.</li>
                </ul>
              </Section>

              <Section id="esas" title="4. Emalın hüquqi əsası">
                <p>Şəxsi məlumatların emalı aşağıdakı hüquqi əsaslara söykənir:</p>
                <ul>
                  <li>İstifadəçinin könüllü, məlumatlı razılığı;</li>
                  <li>Müqavilənin bağlanılması və icrası üçün zərurət;</li>
                  <li>Azərbaycan Respublikasının qanunvericiliyi ilə müəyyən edilmiş öhdəliklərin yerinə yetirilməsi;</li>
                  <li>Bizim və ya üçüncü şəxsin qanuni maraqlarının qorunması.</li>
                </ul>
              </Section>

              <Section id="paylasma" title="5. Üçüncü tərəflərlə paylaşma">
                <p>İnkişafa Dəstək Kreditləri BOKT şəxsi məlumatlarınızı yalnız aşağıdakı hallarda və müvafiq qanunvericilik çərçivəsində üçüncü tərəflərlə paylaşa bilər:</p>
                <ul>
                  <li><strong>Mərkəzi Kredit Reyestri</strong> və Azərbaycan Respublikası Mərkəzi Bankı;</li>
                  <li><strong>Kredit büroları</strong> və kredit tarixçəsi xidmətləri;</li>
                  <li><strong>Hökumət və hüquq-mühafizə orqanları</strong> qanunla nəzərdə tutulmuş hallarda;</li>
                  <li><strong>Audit, hüquqi və mühasibat xidməti</strong> təminatçıları;</li>
                  <li><strong>İT və texniki xidmət</strong> təminatçıları (məxfilik müqaviləsi əsasında).</li>
                </ul>
                <p>
                  Məlumatlarınız heç bir halda kommersiya marketinqi məqsədilə üçüncü tərəflərə satılmır.
                </p>
              </Section>

              <Section id="muddet" title="6. Saxlanılma müddəti">
                <p>
                  Şəxsi məlumatlar yalnız toplanma məqsədinə nail olmaq üçün lazım olan müddət ərzində saxlanılır.
                  Kredit müqaviləsi ilə bağlı məlumatlar Azərbaycan Respublikasının qanunvericiliyinə uyğun olaraq
                  müqavilənin xitamından sonra ən azı <strong>5 (beş) il</strong> müddətinə saxlanılır.
                </p>
              </Section>

              <Section id="huquqlar" title="7. İstifadəçinin hüquqları">
                <p>Sizin aşağıdakı hüquqlarınız vardır:</p>
                <ul>
                  <li>Şəxsi məlumatlarınız haqqında məlumat almaq;</li>
                  <li>Yanlış və ya natamam məlumatların düzəldilməsini tələb etmək;</li>
                  <li>Müəyyən hallarda məlumatların silinməsini tələb etmək;</li>
                  <li>Emalın məhdudlaşdırılmasını tələb etmək;</li>
                  <li>Verdiyiniz razılığı geri çəkmək;</li>
                  <li>Səlahiyyətli orqanlara şikayət vermək.</li>
                </ul>
                <p>
                  Nəzərə alın ki, Azərbaycan Respublikasının qanunvericiliyi ilə müəyyən edilmiş öhdəliklər —
                  o cümlədən kredit müqaviləsi məlumatlarının 6-cı bənddə göstərilən müddət ərzində saxlanılması —
                  razılığın geri çəkilməsindən sonra da qüvvədə qalır və müvafiq məlumatların qanuni müddət
                  bitənədək saxlanılmasına imkan verir.
                </p>
                <p>
                  Bu hüquqlardan istifadə etmək üçün bizimlə aşağıdakı əlaqə kanalları vasitəsilə əlaqə saxlaya bilərsiniz.
                </p>
              </Section>

              <Section id="tehlukesizlik" title="8. Təhlükəsizlik tədbirləri">
                <p>
                  Şəxsi məlumatlarınızın qorunması üçün biz texniki və təşkilati təhlükəsizlik tədbirləri tətbiq edirik —
                  şifrələnmiş əlaqə kanalları, məhdud giriş hüquqları, mütəmadi audit və əməkdaşların məxfilik öhdəlikləri.
                </p>
              </Section>

              <Section id="cookie" title="9. Kuki faylları (Cookies)">
                <p>
                  Saytımız istifadəçi təcrübəsini yaxşılaşdırmaq, əsas funksiyaların işini təmin etmək və analitik
                  məqsədlərlə kuki fayllarından istifadə edir. Bu fayllar cihazınızda kiçik mətn qeydləri şəklində
                  saxlanılır və şəxsi identifikasiyanız üçün istifadə edilmir.
                </p>
                <p>
                  İstənilən vaxt <strong>brauzer parametrlərindən</strong> kuki fayllarını silə, məhdudlaşdıra və ya
                  tam bloklaya bilərsiniz. Nəzərə alın ki, bəzi funksiyaların düzgün işləməsi kuki fayllarından asılıdır.
                </p>
              </Section>

              <Section id="deyisikliklr" title="10. Dəyişikliklər">
                <p>
                  İnkişafa Dəstək Kreditləri BOKT bu Məxfilik siyasətini istənilən vaxt yeniləmək hüququna malikdir. Yenilənmiş versiya bu səhifədə
                  dərc olunduğu andan etibarən qüvvəyə minir və səhifənin başındakı &quot;sonuncu yenilənmə tarixi&quot;
                  müvafiq olaraq yenilənir. Saytdan istifadəni davam etdirməklə siz yenilənmiş Məxfilik siyasətini
                  qəbul etmiş sayılırsınız.
                </p>
              </Section>

              <Section id="elaqe" title="11. Əlaqə məlumatları">
                <p>Məxfilik siyasəti ilə bağlı suallarınız üçün bizimlə əlaqə saxlayın:</p>
                <ul>
                  <li><strong>Elektron ünvan:</strong> info@idkcredit.com</li>
                </ul>
              </Section>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

const Section = ({ id, title, children }) => (
  <div id={id} className="scroll-mt-28">
    <h2 className="text-2xl font-bold text-gray-900 mb-5 pb-3 border-b border-gray-200">
      {title}
    </h2>
    <div className="space-y-4 text-[15px] leading-relaxed [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-2 [&_li]:leading-relaxed [&_strong]:text-gray-900 [&_strong]:font-semibold">
      {children}
    </div>
  </div>
);
